<template>
    <div class='tops_body'>
        <div v-if="(mobileAppHidden === true && showMypageBtn == true) || mobileAppHidden === false" class="tops_body__header">
            <span class='fullName'>{{ familyName }}&nbsp;&nbsp;{{ givenName }}&nbsp;&nbsp;さん</span>
            <button v-if="showMypageBtn == false" class='mypagebutton ml-0' v-on:click='openMyPage'>マイページ</button>
            <button v-else-if="showMypageBtn == true" class='mypage-reserve-update-button' v-on:click='onMypage'>
                <span class="mypage-update-button-text-pc">予約変更画面へ戻る</span>
                <span class="mypage-update-button-text-sp">予約変更画面</span>
            </button>
        </div>
        <ReserveHeader
            @finished-proc="onFinishedProc"
            v-bind:reserveData="reserveData"
        ></ReserveHeader>
        <div class="confirm-body">
            <h2 class="reserve-accent-title bg-single">予約内容の確認</h2>
            <h5 class='font-weight-bold bg-single'>料金</h5>
            <div class='table-back-ground'>
                <table class="confirm-table-body">
                    <tr>
                        <td>お一人様料金</td>
                        <td colspan="2"><span class="total-amount">￥{{ totalPrice }}</span><span> (総額)</span></td>
                    </tr>
                    <tr class="lastColumn" v-if="request_display == false">
                        <td valign="top">キャンセル</td>
                        <td valign="top" style='white-space: pre-line;'>{{ cancelSentence }}</td>
                    </tr>
                </table>
            </div>
            <h5 class='font-weight-bold mt-4 bg-single'>予約詳細</h5>
            <div class='table-back-ground'>
                <table class="confirm-table-body">
                    <tr>
                        <td>プラン名</td>
                        <td>{{ planName }}</td>
                    </tr>
                    <tr>
                        <td>ゴルフ場名</td>
                        <td>{{ golfName }}</td>
                    </tr>
                    <tr>
                        <td>プレー日</td>
                        <td>{{ playDateReplace }}</td>
                    </tr>
                    <tr>
                        <td>スタート時間</td>
                        <td>
                            <span v-for="startTime in startTimeList" :key="startTime.playTimeReplace">
                            {{ startTime.courseName }}&nbsp;&nbsp;&nbsp;{{ startTime.playTimeReplace }}<br>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>人数</td>
                        <td>{{ people }}名様</td>
                    </tr>
                    <tr>
                        <td>プレースタイル</td>
                        <td>
                            <span v-for="icon in iconFlag" :key="icon.id">
                                <div class="play-style-icon" :class="icon.class"></div>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>組数</td>
                        <td>{{cellNum}}組</td>
                    </tr>
                    <tr class="lastColumn">
                        <td valign="top">プラン詳細</td>
                        <td valign="top" style='white-space: pre-line;'>{{ planDetailedSentence }}</td>
                    </tr>
                </table>
            </div>
            <h5 class='font-weight-bold mt-4 bg-single'>お客様情報の確認</h5>
            <div class='table-back-ground'>
                <table class="confirm-table-body">
                    <tr>
                        <td>連絡先</td>
                        <td>
                            <div>
                                <div class="row">
                                    <div class="col-sm-3">お名前</div>
                                    <div class="col-sm-8 text-break">{{ familyName }}&nbsp;&nbsp;{{ givenName }}</div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-3">メールアドレス</div>
                                    <div class="col-sm-9 text-break">{{ email }}</div>
                                </div>
                                <div class="row flex-column flex-sm-row">
                                    <div class="col-sm-3">連絡先電話番号<span class="badge bg-danger text-white badge-required ml-2">※必須</span></div>
                                    <div class="col-sm-3">
                                        <input
                                            type="tel"
                                            class="form-control"
                                            v-model="tel"
                                            @blur="CheckInputData"
                                            @input="CheckInputData"
                                            placeholder="電話番号（固定・携帯）">
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="request_display == false && this.pointSetting === 1">
                        <td v-if="!reserveData.myPageReserveNo">ポイント</td>
                        <td v-if="!reserveData.myPageReserveNo">
                            <div v-if="pointuse_plan = false">現在ポイントは利用できません。</div>
                            <div v-else-if="pointuse_plan = true">
                                <div class="row">
                                    <div class="col-sm-3">ご利用可能ポイント</div>
                                    <div class="col-sm-9 font-weight-bold">{{ this.total_points.toLocaleString() }}pt</div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-3">ポイント利用</div>
                                    <div class="col-sm-3 col-6">
                                        <input
                                            class="text-right form-control"
                                            v-model="usePoint"
                                            type='text'
                                            @blur="CheckInputData"
                                            @input="CheckInputData"
                                        >
                                    </div>
                                    <div class="col-sm-1 mr-auto col-1">pt</div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
                <div v-if="valid" class="valid-message font-weight-bold text-danger text-center d-flex justify-content-center align-items-end">
                {{ validMessage }}
                </div>
            </div>
            <div v-if="request_display == true" style='padding-top: 30px;'>
                <h5 class='font-weight-bold bg-single'>ゴルフ場への連絡事項</h5>
                <div class='table-back-ground'>
                    <table class="confirm-table-body">
                        <tr class="lastColumn">
                            <td valign="center">
                            連絡事項
                            </td>
                            <td valign="top" style="white-space: pre-line;">
                            {{ contactInfo }}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class='d-flex py-3 justify-content-around flex-column flex-sm-row'>
                <div style="flex-grow: .9;"></div>
                <div class="btn nextBtn mb-3" @click.prevent='CompanionAccess' :disabled="processing">予約を確定</div>
                <div style="flex-grow: .5;"></div>
                <div class="btn backBtn mb-3" @click='retrunAccess' ref="afterErr">戻る</div>
            </div>
            <ErrorWordingDialogModal v-show="showErrorWordingDialog" v-bind:errorWording="errorWording" v-on:closeErrorDialog="CloseErrorDialog"></ErrorWordingDialogModal>
        </div>
    </div>
</template>

<script>
import ReserveHeader from './ReserveHeader';
import ErrorWordingDialogModal from '../components/ErrorDialog';
import validater from "../../lib/validater";
import { CODE_MASTER } from '../../config';
import { mapGetters } from "vuex";
import { REGIST_RESERVE_FROM_WEB } from '../../constants/reserve';
import { GET_SELECT_CELL_LIST, GET_PLAN_CELL_INF } from '../../constants/plan_master';
import { utilityMixin } from '../../mixins/utility';

export default {
    components: {
      ReserveHeader,
      ErrorWordingDialogModal
    },
    mixins: [
        utilityMixin
    ],
    data () {
        return {
            planId: null,
            selectDate: null,
            selectDateStr: null,
            cellIdList: [],
            // 枠数（組数）
            cellNum: 0,
            startTimeList: [],
            // エラーダイアログ表示フラグ
            showErrorWordingDialog: false,
            // エラーダイアログの文言
            errorWording: null,
            golfCode: null,
            loginUserMemberNo: 1,
            people: 0,
            totalPrice: null,
            planName: null,
            golfName: null,
            totalFee: null,
            // クエリ用時間日付
            playTime: null,
            // 表示用時間日付
            playDateReplace: null,
            playTimeReplace: null,
            // 予約締切日時用
            closingDays: null,
            closingTime: null,
            iconFlag: [],
            codeList: null,
            courseName: 'OUT',
            // プラン詳細文
            planDetailedSentence: null,
            // キャンセル文
            cancelSentence: null,
            valid: false,
            reserveResult: null,
            reserveType: 1,
            // 予約番号
            reserveNo: null,
            // 連絡事項
            contactInfo: null,
            // エラーメッセージ
            validMessage: '',
            // 連絡先電話番号
            tel: null,
            // 利用ポイント
            usePoint: 0,
            // ポイント利用可能プランフラグ
            pointuse_plan: true,
            // 利用可能ポイント合計
            total_points: 0,
            // 会員情報
            familyName: null,
            givenName: null,
            email: null,
            // リクエスト予約の表示切替（初期値は通常）
            request_display: false,
            // リクエスト予約の入力情報
            firstChoice: null,
            secondChoice: null,
            thirdChoice: null,
            contactInfo: null,
            reserveData: {},
            loadingCount: 0,
            showMypageBtn: false,
            checkResult: false,
            // 多重送信制御用
            processing: false,
            pointSetting: 0,
            // モバイルアプリ非表示フラグ
            mobileAppHidden: false,
            pointSetting: 0
        };
    },
    created () {
        this.initialize();
    },
    computed: {
        ...mapGetters('auth', [
            "loginMemberLineFlag"
        ])
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {

            this.$store.commit("loading/setIsLoading", true);

            // モバイルアプリか判断する
            if (this.$store.state.auth.mobileAppFlag) {
                // モバイルアプリの場合、遷移ボタンを非表示にする
                this.mobileAppHidden = true;
            }

            localStorage.removeItem("Reserve.returnBackUrl");

            this.reserveData = JSON.parse(localStorage.getItem('Reserve.reserveData'));
            // ログイン済みのため会員番号を取得
            this.loginUserMemberNo = this.$store.state.auth.loginMember.member_no;

            // 予約タイプ（通常、リクエスト）
            this.reserveType = this.reserveData.calendarReserveType;

            // 変更時を取得する。
            if (sessionStorage.getItem('MyPage.reserveNo')) {
                // プレー日の変更,プランの変更,スタート時間の変更の場合はMyPage.companionChangeFlgを3にし、
                // 登録処理でbranchNoをカウントアップしないようにする。
                sessionStorage.setItem('MyPage.companionChangeFlg', 3);
            }

            if (sessionStorage.getItem("MyPage.returnBackUrl")) {
                this.showMypageBtn = true;
            }

            // ヘッダ用
            this.loadingOn();

            this.golfCode = this.reserveData.golfCode;
            this.planId = this.reserveData.calendarPlanId;
            this.selectDate = new Date(this.reserveData.calendarSelectDate);
            this.selectDateStr = this.getDateStr(this.selectDate);

            // 通常またはシェア予約の場合
            if (this.reserveType == CODE_MASTER.RESERVE_TYPE_NORMAL ||
                this.reserveType == CODE_MASTER.RESERVE_TYPE_SHARE) {
                this.request_display = false;

                // 前画面の情報を取得{cellId: 枠ID, number: 枠人数}}
                this.cellIdList = this.reserveData.selectCellId;
                // プランと枠情報を取得する
                this.GetPlanDetailed(this.planId, this.cellIdList);
            // リクエストの場合
            } else {
                this.request_display = true;

                this.GetPlanDetailedRequest(this.planId, this.selectDate);
            }

            this.$store.commit("loading/setIsLoading", false);
        },
        /** ----------------------------------------------
         * バリデーションチェック
         * ---------------------------------------------- */
        CheckInputData () {
            this.validMessage = "";
            this.valid = false;
            // メールアドレス形式
            if (this.usePoint) {
                if (!validater.checkIntType(this.usePoint)) {
                    this.validMessage = "ポイント利用は半角数字を入力してください。";
                    this.valid = true;
                } else if (this.total_points < this.usePoint) {
                    this.validMessage = "ご利用可能なポイントの上限を超えています。";
                    this.valid = true;
                }
            }
            if (this.tel) {
                if (!validater.checktelephone(this.tel)) {
                    this.validMessage = "固定電話10桁〜携帯電話11桁の数値を入力してください。";
                    this.valid = true;
                }
            }
            if (!this.tel) {
                this.validMessage = "電話番号を入力してください。";
                this.valid = true;
            }
        },
        /** ----------------------------------------------
         * エラーダイアログを閉じる
         * ---------------------------------------------- */
        CloseErrorDialog () {
            this.showErrorWordingDialog = false;
        },
        /** ----------------------------------------------
         * プラン情報取得（通常またはシェア）
         * ---------------------------------------------- */
        GetPlanDetailed(planId, cellIdList) {

            var cells = [];
            cellIdList.forEach(list => {
                cells.push(list.cellId);
            });

            var dateStr = this.getDateStr(null);

            try {
                this.$apollo.query({
                    query: GET_SELECT_CELL_LIST,
                    variables: {
                        plan_id: planId,
                        cell_id: cells,
                        member_no: this.loginUserMemberNo,
                        golf_group_code: process.env.MIX_GROUP_CODE,
                        golf_code: this.golfCode,
                        target_date: dateStr
                    }
                }).then(res => {
                    var loginUser = res.data.getSelectCellList.Profile[0];
                    this.familyName = loginUser.family_name;
                    this.givenName = loginUser.given_name;
                    this.email = loginUser.email;
                    this.total_points = res.data.getSelectCellList.total_point.total_all;
                    this.pointSetting = res.data.getSelectCellList.point_setting;
                    this.SetPlanDetailed(res.data.getSelectCellList.SelectCellList, cellIdList);
                });
            } catch (error) {
                this.error = error;
                this.$router.push("/starttime");
                this.$store.commit("loading/setIsLoading", false);
            }
        },
        /** ----------------------------------------------
         * プラン情報設定（通常、シェア）
         * ---------------------------------------------- */
        SetPlanDetailed(selectCellList, cellIdList) {
            var planDetailed = selectCellList[0];
            this.planName = planDetailed.plan_name;
            this.golfName = planDetailed.golf_name;
            this.totalPrice = planDetailed.total_fee.toLocaleString();
            this.playDateReplace = this.getDateStrJapanese(this.selectDate);
            this.cancelSentence = planDetailed.cancel_detail;
            this.planDetailedSentence = planDetailed.detail;
            this.cellNum = cellIdList.length;
            this.iconFlag = [];
            if (planDetailed.meal_flag !== CODE_MASTER.NOT_USE_SETTING) {
                this.iconFlag.push({ id: 1, class: planDetailed.meal_flag_icon });
            }
            this.iconFlag.push({ id: 2, class: [planDetailed.cart_code_icon] });
            this.iconFlag.push({ id: 3, class: planDetailed.guarantee_code_icon });
            if (planDetailed.caddie_flag !== CODE_MASTER.NOT_USE_SETTING) {
                this.iconFlag.push({ id: 4, class: planDetailed.caddie_flag_icon });
            }
            this.iconFlag.push({ id: 5, class: planDetailed.round_code_icon });
            if (planDetailed.accommodation_flag !== CODE_MASTER.NOT_USE_SETTING) {
                this.iconFlag.push({ id: 6, class: planDetailed.accommodation_flag_icon });
            }
            this.iconFlag.push({ id: 7, class: planDetailed.share_flag_icon });
            this.closingDays = planDetailed.closing_days;
            this.closingTime = planDetailed.closing_time;

            this.startTimeList = [];
            selectCellList.forEach(cellList => {
                var tempCell = {};
                tempCell["id"] = 1;
                tempCell["courseName"] = cellList.course_name;
                tempCell["playTimeReplace"] = this.getTimeStrJapanese(cellList.play_start);
                this.startTimeList.push(tempCell);
            });

            // 人数を取得
            var cnt = 0;
            cellIdList.forEach(list => {
                cnt = cnt + list.number;
            });
            this.people = cnt;

        },
        /** ----------------------------------------------
         * プラン情報取得（リクエスト）
         * ---------------------------------------------- */
        GetPlanDetailedRequest(planId, targetDate) {
            var targetDateStr = this.getDateStr(targetDate);
            var dateStr = this.getDateStr(null);
            try {
                this.$apollo.query({
                    query: GET_PLAN_CELL_INF,
                    variables: {
                        plan_id: planId,
                        play_date: targetDateStr,
                        member_no: this.loginUserMemberNo,
                        golf_group_code: process.env.MIX_GROUP_CODE,
                        golf_code: this.golfCode,
                        target_date: dateStr
                    }
                }).then(res => {
                    var loginUser = res.data.getPlanCellInf.Profile[0];
                    this.familyName = loginUser.family_name;
                    this.givenName = loginUser.given_name;
                    this.email = loginUser.email;
                    this.total_points = res.data.getPlanCellInf.total_point.total_all;
                    this.SetPlanDetailedRequest(res.data.getPlanCellInf.CellList);
                });
            } catch (error) {
                this.error = error;
                this.$router.push("/requesttimeselect");
                this.$store.commit("loading/setIsLoading", false);
            }
        },
        /** ----------------------------------------------
         * プラン情報設定（リクエスト）
         * ---------------------------------------------- */
        SetPlanDetailedRequest(planDetail) {
            this.planName = planDetail.plan_name;
            this.golfName = planDetail.golf_name;
            this.totalPrice = planDetail.total_fee.toLocaleString();
            this.playDateReplace = this.getDateStrJapanese(this.selectDate);
            this.cancelSentence = planDetail.cancel_detail;
            this.planDetailedSentence = planDetail.detail;
            this.iconFlag = [];
            if (planDetail.meal_flag !== CODE_MASTER.NOT_USE_SETTING) {
                this.iconFlag.push({ id: 1, class: planDetail.meal_flag_icon });
            }
            this.iconFlag.push({ id: 2, class: planDetail.cart_code_icon });
            this.iconFlag.push({ id: 3, class: planDetail.guarantee_code_icon });
            if (planDetail.caddie_flag !== CODE_MASTER.NOT_USE_SETTING) {
                this.iconFlag.push({ id: 4, class: planDetail.caddie_flag_icon });
            }
            this.iconFlag.push({ id: 5, class: planDetail.round_code_icon });
            if (planDetail.accommodation_flag !== CODE_MASTER.NOT_USE_SETTING) {
                this.iconFlag.push({ id: 6, class: planDetail.accommodation_flag_icon });
            }
            this.iconFlag.push({ id: 7, class: planDetail.share_flag_icon });
            this.closingDays = planDetail.closing_days;
            this.closingTime = planDetail.closing_time;

            this.people = this.reserveData.playNumber;
            this.cellNum = this.reserveData.cellNumber;
            this.firstChoice = this.reserveData.firstChoice;
            this.secondChoice = this.reserveData.secondChoice;
            this.thirdChoice = this.reserveData.thirdChoice;
            this.contactInfo = this.reserveData.contactInfo;

        },
        /** ----------------------------------------------
         * 戻るボタン
         * ---------------------------------------------- */
        retrunAccess() {
            if (this.reserveType == CODE_MASTER.RESERVE_TYPE_REQUEST) {
                if (sessionStorage.getItem('Reserve.prevUrl') !== '/starttime') {
                    sessionStorage.setItem('Reserve.prevUrl', "/requesttimeselect");
                }
                sessionStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));

                this.$router.push("/requesttimeselect");
            } else {
                sessionStorage.setItem('Reserve.prevUrl', "/starttime");
                sessionStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
                this.$router.push("/starttime");
            }
        },
        /** ----------------------------------------------
         * 予約を確定
         * ---------------------------------------------- */
        CompanionAccess: async function () {
            if (this.processing) return;
            this.processing = true;
            // エラーが存在している場合
            if (this.valid) {
                this.processing = false;
                this.$refs.afterErr.focus();
                return;
            } else if (!this.tel) {
                this.validMessage = "電話番号を入力してください。";
                this.valid = true;
                this.processing = false;
                this.$refs.afterErr.focus();
                return;
            }
            if (!localStorage.getItem('web-token')) {
                this.validMessage = "ログアウトされています。戻るボタンから予約をやり直してください。";
                this.valid = true;
                this.processing = false;
                this.$refs.afterErr.focus();
                return;
            }
            var cellList = [];
            var cellIdInfoList = [];
            this.cellIdList.forEach(select => {
                cellIdInfoList.push({cellId: select.cellId, number: select.number});
                cellList.push(select.cellId);
            });

            // 予約締切日が過ぎていないかチェック
            var checkClose = this.checkClosingDate(this.selectDateStr, this.closingDays, this.closingTime);
            if (!checkClose) {
                this.validMessage = "予約の締め切り時間が過ぎた日程が選択されています。";
                this.valid = true;
                this.processing = false;
                this.$refs.afterErr.focus();
                return;
            }

            // 同一日に別の予約がないか確認(Mypageからの時は同一日のデータは存在している場合がある)
            var checkDays = 0;
            if (!this.reserveData.myPageReserveNo) {
                this.reserveData.myPageReserveNo = "";
            }

            var cells = [];
            var numbers = [];
            // 通常またはシェア予約の場合
            if (this.reserveType == CODE_MASTER.RESERVE_TYPE_NORMAL ||
                this.reserveType == CODE_MASTER.RESERVE_TYPE_SHARE) {
                this.cellIdList.forEach(list => {
                    cells.push(list.cellId);
                    numbers.push(list.number);
                });
            } else {
              cells.push('0');
            }

            sessionStorage.removeItem('MyPage.reserveBranchNo');


            // ポイント利用配列作成
            this.usePoint = Number(this.usePoint);
            this.loginUserMemberNo = String(this.loginUserMemberNo);
            var actiontext = '予約利用 プレー日(' + this.selectDateStr + ')';
            var pointData = [{
                point: this.usePoint,
                member_no: this.loginUserMemberNo,
                golf_group_code: process.env.MIX_GROUP_CODE,
                golf_code: this.golfCode,
                // 日付と時間の情報を渡す。
                use_date: this.getDateFullStr(null),
                action: actiontext,
                reserve_no: null
            }];


            // メール通知配列作成
            var playTimeList = [];
            var editFlag = false;
            for (let time of this.startTimeList){
                playTimeList.push(time.playTimeReplace);
            }
            // 予約変更時判別用のフラグを変える
            if (this.reserveData.myPageReserveNo) {
                editFlag = true;
            }
            var emailData = [];
            var obj = {
                email: this.email,
                reserve_no: null,
                family_name: this.familyName,
                given_name: this.givenName,
                start_time: playTimeList,
                point: this.usePoint,
                edit_flag: editFlag
            };
            emailData.push(obj);

            var groupInfo = JSON.parse(sessionStorage.getItem('Reserve.groupInfo'));

            // 予約登録処理
            try {
                await this.$apollo.mutate({
                    mutation: REGIST_RESERVE_FROM_WEB,
                    variables: {
                        golf_group_code: process.env.MIX_GROUP_CODE,
                        member_no: this.loginUserMemberNo,
                        golf_code: this.golfCode,
                        plan_id: this.planId,
                        play_date: this.selectDateStr,
                        cell_number: this.cellNum,
                        play_number: this.people,
                        reserve_type: this.reserveType,
                        cell_id: cells,
                        cell_player_number: numbers,
                        contact_tel: this.tel,
                        request_first_choice: this.firstChoice,
                        request_second_choice: this.secondChoice,
                        request_third_choice: this.thirdChoice,
                        request_contact_info: this.contactInfo,
                        reserve_no: this.reserveData.myPageReserveNo,
                        point_list: pointData,
                        reserve_email: emailData,
                        group_info: JSON.stringify(groupInfo)
                    }
                }).then(res => {
                    if (res.data.RegisterReserveFromWeb.result === 1) {
                        this.reserveNo = res.data.RegisterReserveFromWeb.reserve_no;

                        const data = res.data.RegisterReserveFromWeb.reserve_branch_no;
                        if (data != null) {
                            sessionStorage.setItem("MyPage.reserveBranchNo", data);
                        }

                        sessionStorage.setItem('Reserve.reserveNo', this.reserveNo);
                        sessionStorage.setItem('Reserve.reserveType', this.reserveType);
                        sessionStorage.setItem('Reserve.golfCode', this.reserveData.golfCode);
                        sessionStorage.setItem('Reserve.memberRank', this.reserveData.memberRank);

                        //　Mypageからの変更時は同伴者画面へ遷移する
                        if (sessionStorage.getItem('MyPage.companionChangeFlg') == 3) {
                            this.$router.push("/companion-list");
                        } else {
                            this.$router.push("/complete");
                        }
                    } else {
                        this.showErrorWordingDialog = true;
                        this.errorWording = res.data.RegisterReserveFromWeb.error_message;
                        this.processing = false;
                    }
                });
            } catch (error) {
                this.error = error;
                this.showErrorWordingDialog = true;
                this.errorWording = '予約に失敗しました。'
                this.processing = false;
            }
        },
        makeReturnData() {
            // 予約できなかった場合に枠情報を外してデータを再作成する
            const data = JSON.parse(sessionStorage.getItem('Reserve.reserveData'));
            this.reserveData = {
                golfCode: data.golfCode,
                memberNo: data.memberNo,
                memberRank: data.memberRank,
                searchStartDate: data.searchStartDate,
                searchSelectDays: data.searchSelectDays,
                searchSelectCells: data.searchSelectCells,
                searchPriceMin: data.searchPriceMin,
                searchPriceMax: data.searchPriceMax,
                searchStartTimeList: data.searchStartTimeList,
                searchStyleList: data.searchStyleList,
                searchBenefitsList: data.searchBenefitsList,
                calendarPlanId: data.calendarPlanId,
                calendarSelectDate: data.calendarSelectDate,
                calendarReserveType: data.calendarReserveType,
                myPageReserveNo: data.myPageReserveNo
            };
            localStorage.removeItem('Reserve.reserveData');
            localStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function () {
            this.loadingCount++;
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function　() {
            this.loadingCount--;
            if (this.loadingCount <= 0) {
                this.$store.commit("loading/setIsLoading", false);
            }
        },

        /** ----------------------------------------------
         * 子コンポーネントの処理終了通知
         * @param {Boolean} status true:正常  false:異常
         * ---------------------------------------------- */
        onFinishedProc: function (status) {
            if (status) {
                this.loadingOff();
            } else {
                this.$store.commit("loading/setIsLoading", false);
            }
        },
        /** ----------------------------------------------
         * マイページへ処理処理
         * 　
         * ---------------------------------------------- */
        onMypage() {
            this.$router.push('/mypage-reserve-update');
        },
        openMyPage() {
            this.$router.push('/mypage-reserve-list');
        }
    }
}

</script>

<style scoped>
table {
  width: 100%;
}
.valid-message {
    padding-top: 15px;
}
</style>
